<div
  class="diagnostic_detailed_main diagnostic_detailed_main_page website-audit-diagnostics"
  fxLayout="column"
  fxLayoutAlign="flex-start"
  fxFlex="100"
>
  <!-- Page barchart & Piechart container -->
  <div
    class="bug-charts-container bug-charts-container-detail"
    style="display: flex"
  >
    <!-- Page barchart -->
    <div fxFlex="63" *ngIf="firstLoad" style="max-width: 63%; width: 100%">
      <div class="chart-title-container">
        <h2 class="subtitle-h2" *ngIf="firstLoad">Errors by Page</h2>
      </div>

      <div class="pageBarChart-container">
        <div class="pageBarChart-skeleton">
          <span
            class="pageBarChart-skeleton-line"
            *ngFor="let number of skeletonNumbers; let i = index"
            [ngClass]="{
              line1: i == 0,
              line2: i == 1,
              line3: i == 2,
              line4: i == 3,
              line5: i == 4,
            }"
          >
            <span class="pageBarChart-skeleton-line-number">{{
              number
            }}</span></span
          >
        </div>
        <div class="pageBarChart-main">
          <div
            class="pageBarChart-main-charts"
            *ngFor="let page of pages; let i = index"
            (click)="pageChangedFilter(page.name)"
          >
            <div class="pageBarChart-main-charts-bar-container">
              <div
                class="pageBarChart-main-charts-bar"
                [ngStyle]="{ height: page.height, width: page.width }"
              >
                <div
                  class="pageBarChart-main-charts-bar-value"
                  [ngClass]="{
                    zero_value: page.value == 0,
                    tiltBarChartValue: page.value?.toString().length > 10,
                  }"
                >
                  {{ page.value }}
                </div>
              </div>
            </div>
            <div class="pageBarChart-main-charts-name">
              <p>{{ page.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Page barchart skeleton loader -->
    <div
      class="skeleton-box-square"
      style="max-width: 37%; width: 100%"
      *ngIf="!firstLoad"
    >
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '30px',
          width: '250px',
          outline: 'none',
          'background-color': '#37474f1a',
        }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '180px',
          outline: 'none',
          'background-color': '#37474f1a',
          'margin-top': '10px',
        }"
      ></ngx-skeleton-loader>
    </div>

    <!-- Category PieChart -->
    <div fxFlex="37" *ngIf="firstLoad" style="max-width: 37%; width: 100%">
      <div class="chart-title-container">
        <h2 class="subtitle-h2" *ngIf="firstLoad">Errors by Category</h2>
      </div>
      <div class="bugPiechart-container">
        <div class="bugPiechart-container-main">
          <google-chart
            *ngIf="pieBugChart"
            class="chart piechart"
            [data]="pieBugChart"
            (window:resize)="onResize($event)"
            (chartSelect)="categoryChanged($event)"
          >
            <!-- (chartSelect)="bugPieChartSelect($event)" -->
          </google-chart>
        </div>

        <div class="bugPieChart-lengend-container errors-detailed-page">
          <div class="bugPieChart-lengend-titles">
            <p>Category</p>
            <p>Total Errors</p>
          </div>
          <div
            class="bugPieChart-lengend"
            *ngFor="let legend of pieChartLegend"
          >
            <div
              class="bugPieChart-lengend-dot"
              [ngStyle]="{ 'background-color': legend.color }"
            ></div>
            <div class="bugPieChart-lengend-text">
              <p>{{ legend.name }}</p>
              <p>
                {{ legend.value }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pie Chart skeleton loader -->
    <div
      class="bar-chart-box"
      fxFlex="35"
      style="margin-left: 20px; margin-top: 45px"
      *ngIf="!firstLoad"
    >
      <div class="skeleton-box-square">
        <!-- <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '30px',
            width: '250px',
            outline: 'none',
            'background-color': '#37474f1a'
          }"
        ></ngx-skeleton-loader> -->
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '180px',
            outline: 'none',
            'background-color': '#37474f1a',
            'margin-top': '10px',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>

  <!-- Bug Table container -->
  <div class="bug-page-header-buttons_container">
    <mat-form-field
      class="bhm-option-container-1"
      style="--label-name: &quot;Type:&quot;; --form-field-infix-width: 200px"
    >
      <mat-select
        (selectionChange)="typeChanged($event)"
        [(ngModel)]="selectedType"
      >
        <mat-select-trigger>
          <span style="text-transform: capitalize">
            {{ selectedType }}
          </span>
        </mat-select-trigger>

        <mat-option class="bhm-option-select-option-1" value="overall">
          Overall
        </mat-option>
        <mat-option
          class="bhm-option-select-option-1"
          *ngFor="let type of types"
          [value]="type"
        >
          <span style="text-transform: capitalize">
            {{ type }}
          </span>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field
      class="bhm-option-container-1"
      style="--label-name: &quot;Page:&quot;; --form-field-infix-width: 140px"
    >
      <mat-select
        [(ngModel)]="pageFilterActive"
        (selectionChange)="pageChangedFilter(pageFilterActive)"
      >
        <mat-option class="bhm-option-select-option-1" value="overall">
          Show All
        </mat-option>
        <mat-option
          class="bhm-option-select-option-1"
          *ngFor="let page of pages"
          [value]="page?.name"
        >
          {{ page?.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button
      class="custom-button custom-button_clear-filters"
      mat-raised-button
      type="button"
      (click)="clearFilters()"
      *ngIf="pageFilterActive != 'overall' || selectedType != 'overall'"
    >
      <span> Clear filters </span>
    </button>
  </div>
  <!-- Bug Table-->
  <div class="custom_table-container" *ngIf="firstLoad">
    <table class="custom_table">
      <thead>
        <tr>
          <th class="width50 minWidth20"><div>#</div></th>
          <th class="maxWidth140"><div>Page</div></th>
          <th class="maxWidth140"><div>Type</div></th>
          <th class="minWidth200"><div>Issue</div></th>
          <th class="maxWidth140">
            <div>
              Impact
              <svg
                class="custom_table_sort-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                (click)="sortData('impact')"
                [ngClass]="{
                  active: sortKey === 'impact' && sortOrder == 'desc',
                }"
              >
                <g clip-path="url(#clip0_1676_4762)">
                  <path
                    d="M12 8V15"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16 12L12 8"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 12L12 8"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1676_4762">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </th>
          <th class="maxWidth140">
            <div>
              Score
              <svg
                class="custom_table_sort-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                (click)="sortData('score')"
                [ngClass]="{
                  active: sortKey === 'score' && sortOrder == 'desc',
                }"
              >
                <g clip-path="url(#clip0_1676_4762)">
                  <path
                    d="M12 8V15"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16 12L12 8"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 12L12 8"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1676_4762">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </th>
          <th class="minWidth300"><div>Fix</div></th>
          <th class="minWidth300"><div>URL</div></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let error of errors; let i = index">
          <tr>
            <td class="width50 minWidth20">
              {{ i + 1 }}
            </td>
            <td class="maxWidth140">
              {{ error.category }}
            </td>
            <td class="maxWidth140">
              <span style="text-transform: capitalize">
                {{ error.type }}
              </span>
            </td>
            <td class="minWidth200">
              {{ error.issue }}
            </td>
            <td class="maxWidth140">
              <span
                class="label_score_value"
                [class.high_value]="error.impact === 'low'"
                [class.mid_value]="error.impact === 'medium'"
                [class.low_value]="error.impact === 'high'"
              >
                {{ error.impact }}
              </span>
            </td>
            <td class="maxWidth140">
              <span
                class="label_score_value"
                [class.low_value]="error.score >= 80"
                [class.mid_value]="error.score >= 50 && error.score < 80"
                [class.high_value]="error.score < 50"
              >
                {{ error.score }}
              </span>
            </td>
            <td class="minWidth300">
              {{ error.fix }}
            </td>
            <td class="minWidth300">
              {{ error.url }}
            </td>
          </tr>
        </ng-container>
        <ng-container *ngIf="errors.length === 0">
          <tr>
            <td colspan="8" class="text-center">No errors found</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <!-- Bug Table skeleton loader -->
  <div class="skeleton-box-square" fxFlex="100" *ngIf="!firstLoad">
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '30px',
        outline: 'none',
        'background-color': '#37474f1a',
      }"
    ></ngx-skeleton-loader>
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '30px',
        outline: 'none',
        'background-color': '#37474f1a',
        'margin-top': '10px',
      }"
    ></ngx-skeleton-loader>
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '30px',
        outline: 'none',
        'background-color': '#37474f1a',
      }"
    ></ngx-skeleton-loader>
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '30px',
        outline: 'none',
        'background-color': '#37474f1a',
      }"
    ></ngx-skeleton-loader>
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '30px',
        outline: 'none',
        'background-color': '#37474f1a',
      }"
    ></ngx-skeleton-loader>
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '30px',
        outline: 'none',
        'background-color': '#37474f1a',
        'margin-bottom': '150px',
      }"
    ></ngx-skeleton-loader>
  </div>

  <!-- Loader Overlay -->
  <div class="loading-data-overlay" *ngIf="isLoading && firstLoad">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
